import React from 'react';

export default function PaypalErrors({ show, message }) {
  return show && <div className="alert alert-danger">{message}</div>;
}
